module.exports = __webpack_public_path__ + "static/img/418_phase_function_Paper_PointsHejduk_Prediction.114ac68.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/418_phase_function_Paper_PointsHejduk_Prediction.png
// module id = ZIbC
// module chunks = 0